export const getInitials = (firstName: string, lastName: string): string => {
  const getFirstLetter = (name: string): string => name?.trim()?.[0]?.toUpperCase() || "";

  return `${getFirstLetter(firstName)}${getFirstLetter(lastName)}`;
};

